import { useState, useEffect } from "react";
import parse from "html-react-parser";
import { cleanO } from "../../../../utilities/utility";
import QuestionOption from "./questionOption";

const QuestionBox = (props) => {
  const [ch, setCh] = useState("");

  const {
    question,
    socket,
    currentQn,
    setCurrentQn,
    num,
    config,
    qno,
    show,
    ma,
    setMa,
    name,
    linkCode,
    finishAction,
    setIsOpen,
    setImageUrl,
  } = props;

  let options = question.options;

  useEffect(() => {
    const optionContainer = document.querySelector(`.quiz-container[data-qno="${qno}"] .options`);
    const qContainer = document.querySelector(`.qstn-box[data-qno="${qno}"]`);
  
    const handleImageClick = (event) => {
      if (event.target.tagName === "IMG") {
        const clickedImageSrc = event.target.src;
        //console.log("Clicked Image Src:", clickedImageSrc);
        setImageUrl(clickedImageSrc);
        setIsOpen(true);
      }
    };
  
    if (optionContainer) {
      optionContainer.addEventListener("click", handleImageClick);
    }
  
    if (qContainer) {
      qContainer.addEventListener("click", handleImageClick);
    }
  
    return () => {
      if (optionContainer) {
        optionContainer.removeEventListener("click", handleImageClick);
      }
      if (qContainer) {
        qContainer.removeEventListener("click", handleImageClick);
      }
    };
  }, [question]);

  return (
    <>
      <div className="qstn-box" data-qno={qno} style={{ display: show ? "initial" : "none" }}>
        <p className="question-count">
          Question {qno} of {num}
        </p>
        <h2 className="question m-0">{parse(cleanO(question.question))}</h2>
      </div>

      <div className="quiz-container" data-qno={qno} style={{ display: show ? "initial" : "none" }}>
        <div className="options">
          {options.map((option, index) => (
            <QuestionOption
              key={index}
              finishAction={finishAction}
              socket={socket}
              config={config}
              currentQn={currentQn}
              setCurrentQn={setCurrentQn}
              num={num}
              linkCode={linkCode}
              name={name}
              qno={qno}
              question={question}
              ma={ma}
              setMa={setMa}
              on={String.fromCharCode(65 + index)} // Convert index to A, B, C, etc.
              oc={option}
              setCh={setCh}
              isAnswer={ch === String.fromCharCode(65 + index)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default QuestionBox;
